import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AppProvider } from "@/context/AppContext";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Landing from "@/pages/Landing";
import Explorativa from "@/pages/Explorativa";
import Quiz from "@/pages/Quiz";
import QuizResult from "@/pages/QuizResult";
import Confronto from "@/pages/Confronto";
import Organizzativa from "@/pages/Organizzativa";
import Checkin from "@/pages/Checkin";
import ABordo from "@/pages/ABordo";
import FAQ from "@/pages/FAQ";
import Admin from "@/pages/Admin";
import PlausibleOptout from "@/pages/admin/PlausibleOptout";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import ParlarneConQualcuno from "@/pages/ParlarneConQualcuno";
import PianoExcel from "@/pages/PianoExcel";
import { trackPageview } from "@/lib/analytics";

function AppRouter() {
  const location = useLocation();
  // Fire Plausible pageview on every client-side route change
  useEffect(() => {
    trackPageview();
  }, [location.pathname]);
  // Detect OAuth callback synchronously during render
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  // Admin routes: no header/chrome, fully standalone
  if (location.pathname === "/admin") return <Admin />;
  if (location.pathname === "/admin/plausible-optout") return <PlausibleOptout />;
  return (
    <>
      <Header />
      <main className="pb-16 grain">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/esplora" element={<Explorativa />} />
          <Route path="/quiz" element={<Quiz />} />
          <Route path="/quiz/risultato" element={<QuizResult />} />
          <Route path="/confronta" element={<Confronto />} />
          <Route path="/organizza" element={<Organizzativa />} />
          <Route path="/checkin" element={<Checkin />} />
          <Route path="/abordo" element={<ABordo />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/parlarne" element={<ParlarneConQualcuno />} />
          <Route path="/piano-excel" element={<PianoExcel />} />
          <Route path="*" element={<Landing />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </AppProvider>
  );
}
